import { Pipe, PipeTransform } from '@angular/core';
import { AssetAssignmentPL } from '../enums/asset-assignment-pl';
import { AssetAssignment } from '../models/entities/asset-assignment';



@Pipe({
  name: 'asset-assignment-pipe'
})

export class AssetAssignmentPipe implements PipeTransform {
  
  constructor(){}

  transform(assetAssignment: AssetAssignment, field: string): any {
    let result = assetAssignment[field];

     if (field == 'progressLevel') {
      if  (result == AssetAssignmentPL.pl_newly_created)      return "<div class='label-gray'>"    + 'Demande'                + "</div>";
      if  (result == AssetAssignmentPL.pl_confirmed)          return "<div class='label-orange'>"  + 'Demande confirmée'      + "</div>";
      if  (result == AssetAssignmentPL.pl_contract_submitted) return "<div class='label-blue'>"    + 'Contrat envoyé'         + "</div>";
      if  (result == AssetAssignmentPL.pl_contract_signed)    return "<div class='label-orange'>"  + 'Contrat signé'          + "</div>";
      if  (result == AssetAssignmentPL.pl_shipment_planed)    return "<div class='label-orange'>"  + 'Expéditon planifiée'    + "</div>";
      if  (result == AssetAssignmentPL.pl_shipped)            return "<div class='label-orange'>"  + 'Expédié'    + "</div>";
      if  (result == AssetAssignmentPL.pl_delivered)          return "<div class='label-blue'>"    + 'Livré'                  + "</div>";
      if  (result == AssetAssignmentPL.pl_operating)          return "<div class='label-green'>"   + 'En exploitation'        + "</div>";
      if  (result == AssetAssignmentPL.pl_return_requested)   return "<div class='label-orange'>"  + 'Retrait demandé'        + "</div>";
      if  (result == AssetAssignmentPL.pl_redeploy_requested) return "<div class='label-orange'>"  + 'Redéploiment demandé'   + "</div>";
      if  (result == AssetAssignmentPL.pl_return_validated)   return "<div class='label-red'>"     + 'Retrait validé'         + "</div>";
      if  (result == AssetAssignmentPL.pl_return_confirmed)   return "<div class='label-darkgray'>"+ 'Retrait confirmé'       + "</div>";
    }

    return result;
  }
}
